<div class="container h-100 w-100">
  <div class="mx-auto d-flex justify-content-center align-items-center h-100">
    <div class="left-Side-cover w-50 h-100 d-none d-lg-block"></div>
    <div class="right-Side-cover w-50 h-100 d-none d-lg-block"></div>
    <div class="card mb-0 mx-auto w-75">
      <div class="row h-100">
        <!-- Logo and card -->
        <div
          class="col-lg-6 col-sm-12"
          style="min-height: 576px; max-height: 576px"
        >
          <div class="mt-3 pb-5 d-flex flex-column h-100">
            <!-- Logo Div -->
            <div class="text-center">
              <img
                src="assets/caregenix/images/logo/svg-carevance-hori-logo.svg"
                alt="logo"
                class="logo-dark"
              />
            </div>
            <div class="text-center py-2">
              <h4 class="domain-text">
                Choose a domain to unlock personalize domain
              </h4>
            </div>
            <!-- Cards Container -->
            <div
              id="handle-dragula-left"
              class="cardContainer"
              dragula="HANDLE"
            >
              <!-- <app-cards [imageSource]="'assets/caregenix/images/Admin-Portal.png'"
                            [cardTitle]="'Admin Portal'" [cardDescription]="'Founder & CEO'" (onCardClick)="cardEvent('admin')" />
                        <app-cards [imageSource]="'assets/caregenix/images/Care-Management.png'"
                            [cardTitle]="'Care management'" [cardDescription]="'Care managers'" (onCardClick)="cardEvent('care')" />
                        <app-cards [imageSource]="'assets/caregenix/images/patient-Portal.png'"
                            [cardTitle]="'Patient Portal'" [cardDescription]="'For managing Patient Data'" (onCardClick)="cardEvent('patient')" />
                        <app-cards [imageSource]="'assets/caregenix/images/Billing-Portal.png'"
                            [cardTitle]="'Billing-Portal'" [cardDescription]="'For Billing Portal'" (onCardClick)="cardEvent('billing')"/>
                        <app-cards [imageSource]="'assets/caregenix/images/Dr-Portal.png'" [cardTitle]="'Doctor Portal'"
                            [cardDescription]="'For Doctor and patient etc'" (onCardClick)="cardEvent('doctor')" />
                        <app-cards [imageSource]="'assets/caregenix/images/Reportingportalicon.png'"
                            [cardTitle]="'Reporting-Portal'" [cardDescription]="'For Reporting Portal'" (onCardClick)="cardEvent('reporting')"/> -->
              <app-cards
                *ngFor="let item of profileSettingData"
                [isShow]="isCardVisible(item)"
                [imageSource]="item.imageSource"
                [cardTitle]="item.cardTitle"
                [cardDescription]="item.cardDescription"
                (onCardClick)="cardEvent(item)"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 bg-cover d-none d-lg-block p-0">
          <app-image-side customClass="" screenType="userType" />
        </div>
      </div>
    </div>
  </div>
</div>
